import React from "react";

import { Preview } from "@creatomate/preview";

import { Subtitle } from "chq";
import StylesButton from "./StylesButton";
import OptionsDropdown from "./options-dropdown/OptionsDropdown";

interface SubtitleMenuProps {
  changingLanguage: boolean;
  onLanguageChange: (subtitle: Subtitle) => void;
  onSelectTranslation: (value: boolean) => void;
  onShowStyles: () => void;
  preview: Preview;
}

const SubtitleMenu: React.FC<SubtitleMenuProps> = ({
  changingLanguage, onLanguageChange, onSelectTranslation, onShowStyles, preview
}) => (
  <div className="Subtitles-Options">
    <StylesButton onShowStyles={onShowStyles} />
    <OptionsDropdown
      changingLanguage={changingLanguage}
      onLanguageChange={onLanguageChange}
      onSelectTranslation={onSelectTranslation}
      preview={preview}
    />
  </div>
);

export default SubtitleMenu;
